
export const SET_MSG = 'TOMADOR_MSG';
export const SET_EDITAR = 'TOMADOR_EDITAR';
export const SET_LISTA = 'TOMADOR_LISTA';
export const SET_EVENTO = 'TOMADOR_EVENTO';
export const SET_LISTAEVENTO = 'TOMADOR_LISTAEVENTO';
export const SET_LISTADOCUMENTO = 'TRABALHADOR_LISTADOCUMENTO';